import { useQuery } from '@tanstack/react-query';
import { useDemo } from '../../../demo/DemoContext';
import { useWorkspace } from '../../stores';
import { invoicesApi } from '../api/invoicesApi';
export function useInvoice(id: string) {
  const { isDemo, store, scopeKey } = useWorkspace(); const demo = useDemo();
  return useQuery({ queryKey: [...scopeKey, 'invoice', id, isDemo ? demo.revision : 0], queryFn: ({ signal }) => isDemo ? Promise.resolve(demo.invoices.find(i => i.id === id && i.store_id === store?.id) || null) : invoicesApi.get(id, signal), enabled: Boolean(store?.id && id), staleTime: 30_000 });
}
